// src/data/products.js
export const products = [
  {
    id: '1',
    name: 'Salsa de Soya',
    size: '330cc',
    image: '/images/products/soy-sauce-small.jpg',
    description: 'Salsa de soya tradicional, formato personal ideal para uso diario en casa.'
  },
  {
    id: '2',
    name: 'Salsa de Soya',
    size: '1 Litro',
    image: '/images/products/soy-sauce-medium.jpg',
    description: 'Salsa de soya tradicional, formato familiar para un uso más prolongado.'
  },
  {
    id: '3',
    name: 'Salsa de Soya',
    size: '5 Litros',
    image: '/images/products/soy-sauce-large.jpg',
    description: 'Salsa de soya tradicional, formato comercial ideal para restaurantes.'
  },
  {
    id: '4',
    name: 'Salsa Teriyaki',
    size: '330cc',
    image: '/images/products/teriyaki-small.jpg',
    description: 'Salsa teriyaki, formato personal perfecto para marinar y cocinar.'
  },
  {
    id: '5',
    name: 'Salsa Teriyaki',
    size: '1 Litro',
    image: '/images/products/teriyaki-medium.jpg',
    description: 'Salsa teriyaki, formato familiar para todas tus recetas.'
  },
  {
    id: '6',
    name: 'Salsa Teriyaki',
    size: '5 Litros',
    image: '/images/products/teriyaki-large.jpg',
    description: 'Salsa teriyaki, formato comercial para negocios gastronómicos.'
  }
];